import loadable from "@loadable/component"
import { useLocation } from "react-router-dom"

import IntersectionWrapper from "components/common/intersection-wrapper"
import { retry, IS_US } from "helpers/application"

const FooterBottom = loadable(() => retry(() => import("./footer-bottom")))
const FooterContent = loadable(() => retry(() => import("./footer-content")))
const FooterSubscribe = loadable(() =>
  retry(() => import("./footer-subscribe"))
)

const FooterMain = () => {
  const location = useLocation()

  if (
    location.pathname.includes("/checkout") ||
    location.pathname.includes("/payments")
  ) {
    return ""
  }

  return (
    <IntersectionWrapper id="footer-wrapper">
      {!IS_US() && <FooterSubscribe />}
      <footer className="bg-black-print widescreen:py-60 py-32">
        <FooterContent />
        <FooterBottom />
      </footer>
    </IntersectionWrapper>
  )
}

export default FooterMain
